$(function(){
  initflickityBannerCol();
  initflickitycolList();
  initflickityRecommend();
  onloadimgswap();

  if (location.href.includes('/collection')) {
    onloadCollectionFIlter();
    onloadCollectionReadMore();
  }

  onload_announcementBarText();
  initflickityAnnouncement();

  cartJsEvent();
  removeMainnotfull();
  masterPromo(false);
  tierGwp();
  // document.addEventListener('cart:updated', function(evt) {
  //   masterPromo(false);
  // });
  // $(document).on('cart.requestComplete', function(event, cart) {
  //   document.dispatchEvent(new CustomEvent('cart:build'));
  //   setTimeout(function(){
  //     if ($('.cart__items[data-count="0"]').length > 0) {
  //       location.reload();
  //     }
  //   },1000);
  // });
  // document.addEventListener('ajaxProduct:added', function(evt) {
  //   masterPromo(false);
  // });
  $(document).on('cart.requestComplete', function(event, cart) {
    getThis._rerenderReplaceRefreshCart().then(function () {
        //getThis.sidebarDrawer.open();
        //getThis._loadRecommendations1().then(getThis._createSlideshow.bind(getThis));
    });
  });

  onloadRemoveSigi();

  if (location.href.includes('/cart')) {
    var cartPopup = $('.jsc-enable-cartpopup').val();

    if (cartPopup == 'true') {
      onloadCartPopup();
    }
  }

  if (location.href.includes('/product')) {
    initflickityImageSlider();
    // onloadStickyATC();

    setTimeout(function(){
      var $ymal = $('.pdp-ProductRecommendations').length;

      if ($ymal > 0) {
        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
      }
    },1500);
  }
});

cartJsEvent = () =>{
  $(document).on('cart.requestStarted', function(event, cart) {
    $('.jsc-loader-overlay').removeAttr('style');
    $('.Cart__Checkout').attr('disabled',true);
  });
  $(document).on('cart.requestComplete', function(event, cart) {
    $('.jsc-loader-overlay').css('display','none');
    $('.Cart__Checkout').removeAttr('disabled');
    //location.reload();
  });
}
masterPromo = (isDrawer) =>{
  setTimeout(function(){
    cartGift();
  },1000);
}

cartJSAddQuery = (vid, qty, obj) => {
  // Cart js add item, success callback, error callback

  CartJS.addItem(vid, qty, obj,
  {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            quantity: 1
           }
        }));
      // $.ajax({
      //   url: '/cart.js',
      //   dataType: "json",
      //   cache: false,
      //   beforeSend: function() {
      //     console.log('before');
      //   },
      //   success: function(cart) {
      //     /*
      //     getThis.element.dispatchEvent(new CustomEvent('product:added', {
      //       bubbles: isOpenDrawer,
      //       detail: {
      //         variant: vid,
      //         quantity: qty
      //       }
      //     }));
      //     */
      //   }
      // });
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
    }
  });
}


cartJSUpdateQuery = (vid, qty, obj, isOpenDrawer) => {
  // Cart js add item, success callback, error callback

  CartJS.updateItemById(vid, qty, obj,
  {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        beforeSend: function() {
          console.log('before');
        },
        success: function(cart) {
          /*
          getThis.element.dispatchEvent(new CustomEvent('product:added', {
            bubbles: isOpenDrawer,
            detail: {
              variant: vid,
              quantity: qty
            }
          }));
          */
        }
      });
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
    }
  });
}

onhoverColPDP = (col, evt) => {

  if ($(window).width() <= 1025) return;

  var wrapper = $(evt).closest('.ColorSwatchList'); // scope fix
  if(!wrapper.length) return;

  wrapper.find('.cfilc').hide();
  wrapper.find('.jsc-col-current').hide();

  wrapper.find('.jsc-col.cfilc').show().text(col);
}


onhoverColPDPdefault = (evt) => {

  if ($(window).width() <= 1025) return;

  var wrapper = $(evt).closest('.ColorSwatchList'); // scope fix
  if(!wrapper.length) return;

  wrapper.find('.jsc-col').hide();
  wrapper.find('.jsc-col-current').show();
}
onhoverShowColor = (e) => {
  // var $this = $(e);
  // if ($(window).width() >= 1024) {
  //   $this.find('.jsc-show-on-hover').show().css({'display':'flex','justify-content':'center'});
  // }

  //console.log($this);
}
onhoverHideColor = (e) => {
  // var $this = $(e);
  // $this.find('.jsc-show-on-hover').hide();
}
onhoverCollectionSwatch = (e,color) => {
  var $this = $(e);
  $('.cfilc').hide();
  $this.parents('.Collapsible').find('.Collapsible__Button .jsc-filter-swatch.cfilc').show();
  $this.parents('.Collapsible').find('.Collapsible__Button .jsc-filter-swatch.cfilc').text(color);
  //console.log(color);
}
outhoverHideCollectionSwatch = () => {
  $('.Collapsible__Button .jsc-filter-swatch.cfilc').hide();
}

initflickityBannerCol = () =>{
  if ($('.jsc-col-banner-wrap').length > 0) {
    $('.jsc-col-banner-wrap').flickity({
      // options
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      groupCells: true,
      prevNextButtons: false,
      freeScroll: false,
      wrapAround: true,
      autoPlay: 2000,
      draggable: true,
      on: {
        ready: function() {
          $(this.element).addClass('jsc-flickity-initiated');
        }
      }
    });
  }
}
onclickInitflickityBannerCol = () =>{
  setTimeout(function(){ console.log($('.jsc-col-banner-wrap').length);
    if ($('.jsc-col-banner-wrap').length > 0) {
      $('.jsc-col-banner-wrap').flickity({
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        groupCells: true,
        prevNextButtons: false,
        freeScroll: false,
        wrapAround: true,
        autoPlay: 2000,
        draggable: true,
        on: {
          ready: function() {
            $(this.element).addClass('jsc-flickity-initiated');
          }
        }
      });
    }
  },2000);

}

initflickitycolList = () =>{
  if ($('.jsc-col-list-carousel').length > 0) {
    $('.jsc-col-list-carousel').flickity({
      // options
      prevNextButtons : true,
      pageDots : false,
      wrapAround : false,
      contain : true,
      cellAlign : "left",
      dragThreshold : 8,
      groupCells : true,
      imagesLoaded : true,
      on: {
        ready: function() {
          $(this.element).addClass('jsc-flickity-initiated');
        }
      }
    });
  }
}

initflickityRecommend = () => {
  setTimeout( function() {
    if ($('.jsc-ProductRecommendations .ProductList.ProductList--carousel.Carousel').length > 0) {
      console.log('flick');
      $('.jsc-ProductRecommendations .ProductList.ProductList--carousel.Carousel').flickity({
        // options
        prevNextButtons : true,
        pageDots : false,
        wrapAround : false,
        contain : true,
        cellAlign : "left",
        dragThreshold : 8,
        groupCells : true,
        imagesLoaded : true,
        on: {
          ready: function() {
            $(this.element).addClass('jsc-flickity-initiated');
          }
        }
      });
    }
  },3500);

}


onload_announcementBarText = (e) => {
  var $currentCurrency = $('.jsc-currency-code').val();


  $('.jsc-text-update').hide();
  if ($currentCurrency == 'SGD') {
    $('.jsc-text-update.jsc-text-sgd').show();
  }
  else if ($currentCurrency == 'MYR') {
    $('.jsc-text-update.jsc-text-myr').show();
  }
  else if ($currentCurrency == 'IDR') {
    $('.jsc-text-update.jsc-text-idr').show();
  }
  else if ($currentCurrency == 'JPY') {
    $('.jsc-text-update.jsc-text-jpy').show();
  }
  else if ($currentCurrency == 'PHP') {
    $('.jsc-text-update.jsc-text-php').show();
  }
  else if ($currentCurrency == 'HKD') {
    $('.jsc-text-update.jsc-text-hkd').show();
  }
  else if ($currentCurrency == 'TWD') {
    $('.jsc-text-update.jsc-text-twd').show();
  }
  else if ($currentCurrency == 'USD') {
    $('.jsc-text-update.jsc-text-usd').show();
  }
  else {
    $('.jsc-text-update.jsc-text-rotw').show();
  }
}

ctsSizeSelect = (e,varID,varTitle,varAvail,tag) => {
  // console.log(varID,varTitle);
  var $this = $(e);
  var $parentThis = $this.parents('.jsc-size-variants').siblings('.jsc-data-var-cts');
  var $varTitle = $parentThis.attr('data-var-title',varTitle);
  var $varID = $parentThis.attr('data-var-id',varID);
  var $varAvail = $parentThis.attr('data-var-avail',varAvail);
  var $atcBtn = $parentThis.siblings('.jsc-product-atc-pdp');

  console.log("varID",$varID);

  //add 'selected color' Styles
  $this.siblings().addClass('selected');
  $this.siblings().addClass('jsc-ColorSwatch-selected');
  //remove other 'selected color'
  $this.parents('.jsc-ProductItem-size').siblings().find('label').removeClass('selected').removeClass('jsc-ColorSwatch-selected');

  if ((varAvail == 'false') && (tag == 'true')) {
    $atcBtn.find('span').html('Coming Soon');
    $atcBtn.html('Coming Soon');
    $atcBtn.attr('disabled','disabled');
    $atcBtn.addClass('jsc-comingSoon');
    console.log('coming soon');
  }
  else if ((varAvail == 'false') && (tag == 'false')) {
    console.log('notify me');
    $atcBtn.html('Sold Out');
    $atcBtn.attr('disabled','disabled');
    $atcBtn.addClass('jsc-soldout');
    // $atcBtn.attr('id','BIS_trigger');
    $atcBtn.removeClass('jsc-comingSoon');
    $this.parents('.ProductItem__Wrapper').find('.jsc-ymal-atc-button').addClass('d-none');
    $this.parents('.ProductItem__Wrapper').find('.jsc-grid-NF').removeClass('d-none');
    $this.parents('.ProductItem__Wrapper').find('.jsc-grid-NF').show();
  }
  else {
    $atcBtn.removeAttr('disabled');
    $atcBtn.removeClass('jsc-soldout');
    $atcBtn.find('span').html('Add to Cart');
    $atcBtn.html('Add to Cart');
    $atcBtn.removeAttr('id');
    $atcBtn.attr('onclick','jscATC_cts(this)');
    console.log('add to cart',$this.parents('.ProductItem__Wrapper').find('.jsc-ymal-atc-button').length);
    $atcBtn.removeClass('jsc-comingSoon');
    $this.parents('.ProductItem__Wrapper').find('.jsc-ymal-atc-button').removeClass('d-none');
    $this.parents('.ProductItem__Wrapper').find('.jsc-grid-NF').addClass('d-none');
    $this.parents('.ProductItem__Wrapper').find('.jsc-grid-NF').hide();
    $this.parents('.ProductItem__Wrapper').find('.jsc-ymal-atc-button').show();
  }

}
// jscATC_cts = (e) => {
  
//   var $this = $(e);
//   var $siblingThis = $this.siblings('.jsc-data-var-cts');
//   var $varTitle = $siblingThis.attr('data-var-title');
//   var $varID = $siblingThis.attr('data-var-id');

//   console.log($varTitle,$varID,"hellohy");
//   cartJSAddQuery($varID, 1, {});

//   /*
//   setTimeout(function() {
//     location.reload();
//   },1200);
//   */
// }
jscATC_cts = (e, element) => {
  e.preventDefault(); // Prevents form submission
  var $this = $(element);  // Get the clicked button
  var $siblingThis = $this.siblings('.jsc-data-var-cts');
  var $varTitle = $siblingThis.attr('data-var-title');
  var $varID = $siblingThis.attr('data-var-id');

  console.log("Adding:", $varTitle, $varID);

  if ($varID) {
    console.log("klk");
    cartJSAddQuery($varID, 1, {}); // AJAX Add to Cart
  } else {
    console.error("Error: Variant ID not found.");
  }
};

jscSelectSize = (e) => {
  $(e).siblings('input').prop("checked", true);
  $(e).parents('.jsc-ProductItem-size').siblings().find('input').prop("checked", false);
}
showComingSoonBtn = (e,varAvailable,tag) => {
  var $this = $(e);
  var $atcButton = $this.parents('.ProductForm__Variants').siblings('.jsc-qty-atc-wrap').find('.jsc-product-atc-pdp');
  $atcButton.removeClass('jsc-soldout');

  if ((varAvailable == 'false') && (tag == 'true') ) {

    setTimeout(function() {
      $atcButton.removeAttr('id');
      $atcButton.html('Coming Soon');
      $atcButton.attr('disabled','disabled');
      $atcButton.addClass('jsc-comingSoon');
      // console.log($atcButton);
    },0);
  }
  
  else {
    if (varAvailable == 'false') {
      $atcButton.addClass('jsc-soldout');
    } else {
      $atcButton.removeAttr('disabled');
      $atcButton.removeClass('jsc-comingSoon');
    }
    
  }
  
  
  setTimeout(function(){
    var $default_atc_btn = $('.jsc-qty-atc-wrap .jsc-main-atc');
    if ($default_atc_btn.attr('disabled')) {
      var varAvailable = 'false';
    } else {
      var varAvailable = 'true';
    }
    updateStickyATCsection(varAvailable);
  },100);
  
}

reloadPage = () => {
  setTimeout( function() {
    location.reload();
  },1000);
}

//start: gwp
cartGift = () =>{
  addCartGift();
  removeCartGift();
  addTeeBundle();
  removeTeeBundle();
}

addCartGift = () =>{
  var $elem = $('#jsc-cart-gift');
  var $vid = $elem.val();
  var $obj = {};
  var $promoNo = $elem.attr('data-promo');
  var removeGift = sessionStorage.getItem("FreeGift");

  

  $obj['_Cart_Gift'] = $promoNo;
  $obj['_Cart_GWP'] = 'Free Gift';
  if ($elem.length > 0 ) {
    if (removeGift != 'Remove') {
      console.log('add gwp',$vid);
      cartJSAddQuery($vid,1,$obj,true);
    }

  }

}

removeCartGift = () =>{
  var $elem = $('#jsc-cart-gift-remove');
  var $key = $elem.val();

  if ($elem.length > 0) {
    console.log('remove gwp');
    cartJSUpdateQuery($key, 0, {}, true);
  }

  //start:check if gwp more than 1, remove the rest
  var $reduce_gwp = $('.jsc-reduce-gwp');
  var $reduce_key = $reduce_gwp.val();
  if ($reduce_gwp.length > 0) {
    console.log('reduce gwp',$reduce_key);
    cartJSUpdateQuery($reduce_key, 1, {}, true);
  }
  //end:check if gwp more than 1, remove the rest
}
//end: gwp

//start: tee bundle
addTeeBundle = () =>{
  var $elem = $('.jsc-tee-bundle');
  var $vid = parseInt($elem.attr('data-new-product'));
  var $qty = $elem.attr('data-qty');
  var $obj = {};
  var $promoNo = $elem.attr('data-promo');

  // $obj['_Cart_Gift'] = $promoNo;
  $obj['_Bundle_Virtual'] = 'Yes';
  if ($elem.length > 0 ) {
    
      console.log('add tee bundle',$vid);
      cartJSAddQuery($vid,$qty,$obj,true);
  }

}
removeTeeBundle = () =>{
  var $elem = $('.jsc-tee-bundle-remove');
  var $key = parseInt($elem.attr('data-new-product'));

  if ($elem.length > 0) {
    console.log('remove tee bundle',$key);
    cartJSUpdateQuery($key, 0, {}, true);
  }

  //start:check if gwp more than real bundle, remove the rest
  var $reduce_gwp = $('.jsc-update-bundle-gwp');
  var $reduce_key = $reduce_gwp.val();
  var $reduce_qty = $reduce_gwp.attr('data-qty');
  if ($reduce_gwp.length > 0) {
    console.log('reduce gwp',$reduce_key);
    cartJSUpdateQuery($reduce_key, $reduce_qty, {}, true);
  }
  //end:check if gwp more than real bundle, remove the rest
}
//end: tee bundle


initflickityAnnouncement = () =>{ console.log('test slick');
  if ($('.jsc-flickity-announcement').length > 0) { console.log('test slick2');
    // $('.jsc-flickity-announcement').slick({
    //   vertical: true,
    //   verticalSwiping: true,
    //   autoplay: true,
    //   autoplaySpeed: 2000,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   prevArrow: false,
    //   nextArrow: false
    // });

    $('.jsc-flickity-announcement').flickity({
      // options
      cellAlign: 'center',
      contain: true,
      pageDots: false,
      groupCells: true,
      prevNextButtons: false,
      freeScroll: false,
      wrapAround: true,
      autoPlay: 4000,
      draggable: true,
      on: {
        ready: function() {
          $(this.element).addClass('jsc-flickity-initiated');
        }
      }
    });
  }
}

onloadRemoveSigi = () => {
  var discountSigi = $('.jsc-remove-sigi');

  discountSigi.each(function() {
    var discountTitle = $(this).attr('data-discount-title');
    var $key = $(this).attr('data-id');
    if (discountTitle == '') {
        cartJSUpdateQuery($key, 0, {}, true);
    }
    
  });
 
}

jscShowMoreCollection = () => {
  var showmore_btn = $('.jsc-desc-showmore-div.d-none');
  // console.log(showmore_btn.length);
  if (showmore_btn.length > 0) {
    showmore_btn.removeClass('d-none');
    // console.log('to show');
  } else {
    $('.jsc-desc-showmore-div').addClass('d-none');
    // console.log('to hide');
  }
  
}

onloadCartPopup = () => {
  var storeCurrency = $('.jsc-currency-code').val();
  var cartRange;
  var cartRangeMax;
  var range_sgd = $('.jsc-cartrange-sgd').attr('data-range');
  var range_myr = $('.jsc-cartrange-myr').attr('data-range');
  var range_hkd = $('.jsc-cartrange-hkd').attr('data-range');
  var range_idr = $('.jsc-cartrange-idr').attr('data-range');
  var range_jpy = $('.jsc-cartrange-jpy').attr('data-range');
  var range_usd = $('.jsc-cartrange-usd').attr('data-range');

  var max_sgd = $('.jsc-cartrange-sgd').attr('data-maxrange');
  var max_myr = $('.jsc-cartrange-myr').attr('data-maxrange');
  var max_hkd = $('.jsc-cartrange-hkd').attr('data-maxrange');
  var max_idr = $('.jsc-cartrange-idr').attr('data-maxrange');
  var max_jpy = $('.jsc-cartrange-jpy').attr('data-maxrange');
  var max_usd = $('.jsc-cartrange-usd').attr('data-maxrange');

  if (storeCurrency == 'MYR') {
    
    cartRange = parseInt(range_myr) * 100;
    cartRangeMax = parseInt(max_myr) * 100;
  }
  else if(storeCurrency == 'SGD'){
    cartRange = parseInt(range_sgd) * 100;
    cartRangeMax = parseInt(max_sgd) * 100;
  }
  else if(storeCurrency == 'HKD'){
    cartRange = parseInt(range_hkd) * 100;
    cartRangeMax = parseInt(max_hkd) * 100;
  }else if(storeCurrency == 'IDR'){
    cartRange = parseInt(range_idr) * 100;
    cartRangeMax = parseInt(max_idr) * 100;
  }
  else if(storeCurrency == 'JPY'){
    cartRange = parseInt(range_jpy) * 100;
    cartRangeMax = parseInt(max_jpy) * 100;
  }
  else if(storeCurrency == 'USD'){
    cartRange = parseInt(range_usd) * 100;
    cartRangeMax = parseInt(max_usd) * 100;
  }

  console.log(storeCurrency,cartRange,cartRangeMax);

  $.when($.getJSON('/cart.js', function(cart) {
    _totalPrice = cart.total_price;
    _cartItems = cart.items;
    console.log(_totalPrice);
  })).then(function(){

    if ( (_totalPrice >= cartRange) && (_totalPrice <= cartRangeMax) ) {
      $('#myModal').css('display','flex');
    }

  });
}
jscNewsletterButton = (e) => {
  $(e).siblings('.NewsletterPopup').attr('aria-hidden','false');
  var $popupStatus = $(e).siblings('.NewsletterPopup').attr('aria-hidden');
  if ($popupStatus == 'false') {
    // console.log('hide');
    $(e).css('opacity','0');
  }
}
jscShowNewsletterButton = (e) => {
  console.log('show');
  $('.jsc-newsletter-buttons').css('opacity','1');
}
jscTopFilter = (e) => {
  var $e = $(e);
  // var $thisClass = $e.attr() 
  var $thisContentDiv = $e.siblings('.Collapsible__Inner');
  var $thisContentClasses = $thisContentDiv.attr('class');
  var $OtherContentDiv = $e.parents('.Collapsible').siblings();

  if ($thisContentClasses.includes('d-none')) {
    $thisContentDiv.removeClass('d-none');
    console.log('buka');
    $OtherContentDiv.find('.Collapsible__Inner').addClass('d-none');
    // console.log('tutup yg lain',$OtherContentDiv)
  } else {
    $thisContentDiv.addClass('d-none');
    console.log('tutup');
    $OtherContentDiv.find('.Collapsible__Inner').addClass('d-none');
  }

}
onloadCollectionFIlter = () => {
  var $outputDiv = $('.jsc-filter-output');
  var $outputEach = $outputDiv.find('.jsc-each-filter .jsc-each-selected-filter');
  var $outputFilter = $outputDiv.find('.jsc-each-filter');
  var $thisCollection = $outputDiv.attr('data-collection');
  var $filterName;
  var $filterResult;
  var $filterIndex;
  var updateContent;

  // setInterval(function(){},1000);
  setTimeout(function() {
    var $pageUrl = window.location.href;
    var $removeCollectionFromUrl = $pageUrl.split($thisCollection)[1];
    var $removeSortByFilter = $removeCollectionFromUrl.split('?sort_by')[0].replace('/', '');

    if ($removeSortByFilter != '') {
      $outputDiv.removeClass('d-none');
      var splitText = $removeSortByFilter.split('+');  
      
      $.each(splitText, function(index, value) {
        
        $filterName = value.split('_')[0];
        $filterResult = value.split('_')[1];
        $filterIndex = index + 1;
        $capFilterName = $filterName.charAt(0).toUpperCase() + $filterName.slice(1);

        var text = value;
        var parts = text.split('_'); // Split the text at the underscore
        var firstWord = parts[0].charAt(0).toUpperCase() + parts[0].slice(1); // Capitalize the first word
        var firstWord_new = firstWord.replace('-',' ');
        var capitalizedFirstWord = firstWord_new.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); }); // cap first character of each text
        var secondWordNumber = parts[1].replace('1-','').replace('2-','').replace('3-','');
        var secondWord = secondWordNumber.split('-').map(function(word) {
          if ($filterName == 'size') {
            return word.toUpperCase();
          } else {
            return word.charAt(0).toUpperCase() + word.slice(1);
          }
        }).join(' '); // Capitalize each word after splitting at the hyphen and rejoin with a space
        var finalText = capitalizedFirstWord + ': ' + secondWord; // Concatenate the parts
        
        var decodedText = decodeURIComponent(finalText); // Decode the URL-encoded text
        var transformedText = decodedText.replace('-', '_'); // Convert to lowercase and replace hyphens with underscores
        if ($filterName == 'size') {
          var filterOnly = transformedText.split('?PAGE')[0];
        } else {
          var filterOnly = transformedText.split('?page')[0];
        }
        
        // console.log(filterOnly,transformedText); 

        $outputEach.each(function() {
          $(this).remove();          
        });
        updateContent = '<div class="jsc-each-selected-filter is-active" data-selected="" data-index="' + $filterIndex +'" data-tag="' + value + '" onclick="jscRemoveEachFilter(this);onclickInitflickityBannerCol();">' + filterOnly + '<span class="jsc-filter-close"></span></div>';
        $outputFilter.append(updateContent);
        
      });
      
    }
    else {

    }

  },1000);
}
jscSelectedFilter = (e) => {
  var $thisParentContent = $(e).parents('.Collapsible__Inner');
  var $thisData = $(e).attr('data-tag');

  var $outputDiv = $('.jsc-filter-output');
  var $outputEach = $outputDiv.find('.jsc-each-filter .jsc-each-selected-filter');
  var $outputFilter = $outputDiv.find('.jsc-each-filter');
  var $thisCollection = $outputDiv.attr('data-collection');
  var updateContent;
  var $filterName;
  var $filterResult;
  var $filterIndex;

  $thisParentContent.addClass('d-none'); // close the dropdown after select
  $outputDiv.removeClass('d-none');

  setTimeout(function() {
    var $pageUrl = window.location.href;
    var $removeCollectionFromUrl = $pageUrl.split($thisCollection)[1];
    var $removeSortByFilter = $removeCollectionFromUrl.split('?sort_by')[0].replace('/', '');
    $outputFilter.remove('.jsc-each-selected-filter');

    var splitText = $removeSortByFilter.split('+');

    $.each(splitText, function(index, value) {
      
      $filterName = value.split('_')[0];
      $filterResult = value.split('_')[1];
      $filterIndex = index + 1;
      $capFilterName = $filterName.charAt(0).toUpperCase() + $filterName.slice(1);

      var text = value;
      var parts = text.split('_'); // Split the text at the underscore
      var firstWord = parts[0].charAt(0).toUpperCase() + parts[0].slice(1); // Capitalize the first word
      var firstWord_new = firstWord.replace('-',' ');
      var capitalizedFirstWord = firstWord_new.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); }); // cap first character of each text
      var secondWordNumber = parts[1].replace('1-','').replace('2-','').replace('3-','');
      var secondWord = secondWordNumber.split('-').map(function(word) {
        if ($filterName == 'size') {
          return word.toUpperCase();
        } else {
          return word.charAt(0).toUpperCase() + word.slice(1);
        }
      }).join(' '); // Capitalize each word after splitting at the hyphen and rejoin with a space
      var finalText = capitalizedFirstWord + ': ' + secondWord; // Concatenate the parts
        
      var decodedText = decodeURIComponent(finalText); // Decode the URL-encoded text
      var transformedText = decodedText.replace('-', '_'); // Convert to lowercase and replace hyphens with underscores
      console.log(capitalizedFirstWord); 

      $outputEach.each(function() {
        $(this).remove();
      });
      updateContent = '<div class="jsc-each-selected-filter is-active" data-selected="" data-index="' + $filterIndex +'" data-tag="' + value + '" onclick="jscRemoveEachFilter(this);onclickInitflickityBannerCol();">' + transformedText + '<span class="jsc-filter-close"></span></div>';
      $outputFilter.append(updateContent);
      
    });

  },500);
  
}

jscRemoveEachFilter = (e) => {
  var $outputDiv = $('.jsc-filter-output');
  var $thisCollection = $outputDiv.attr('data-collection');

  getThis._toggleTagJSC(e);
  $(e).remove();

  setTimeout(function() {
    var $pageUrl = window.location.href;
    var $removeCollectionFromUrl = $pageUrl.split($thisCollection)[1];
    var $removeSortByFilter = $removeCollectionFromUrl.split('?sort_by')[0].replace('/', '');
    // console.log($pageUrl,$removeSortByFilter);
    if ($removeSortByFilter == '') {
      $outputDiv.addClass('d-none');
    }
  // 
  },500);
}

jscResetFilter = () => {
  var $outputDiv = $('.jsc-filter-output');
  var $outputEach = $outputDiv.find('.jsc-each-filter .jsc-each-selected-filter');

  $outputEach.each(function() {
    $(this).remove();
  });
  $outputDiv.addClass('d-none');
}

var $imgContainer = $('.jsc-product-gallery-new-layout');
var $childArrayElement = $imgContainer.find('.Product__SlideItem');

destroyProductSlider = () =>{
  $('.jsc-product-gallery-new-layout').flickity();
  $('.jsc-product-gallery-new-layout').flickity('destroy');
}
onloadimgswap = () => {
  if ($(window).width() < 1009 ) {
    var col = $('.ColorSwatch__Radio:checked').val();
    destroyProductSlider();
    $imgContainer.children().remove();

    console.log("Selected:", col);

    var matched = false;

    // Try to match alt with selected color
    for (var i = 0; i < $childArrayElement.length; i++) {
      var $thisAltText = $($childArrayElement[i]).attr('data-alt');
      if ($thisAltText && $thisAltText === col) {
        $imgContainer.append($childArrayElement[i]);
        matched = true;
      }
    }

    // Fallback: if no match, show all images
    if (!matched) {
      for (var i = 0; i < $childArrayElement.length; i++) {
        $imgContainer.append($childArrayElement[i]);
      }
    }

    $imgContainer.children().removeClass('d-none').addClass('is-selected');
    $imgContainer.flickity({
      cellAlign: 'left',
      prevNextButtons: true,
      pageDots: false,
      adaptiveHeight: true,
      dragThreshold: 8
    });
  } else {
    destroyProductSlider();
  }
}


function showImageLabel() {

  // sab label hide
  $('.jsc-image-label-container').addClass('d-none');

  var $visibleSlides = $('.Product__SlideItem:not(.d-none)');
  if (!$visibleSlides.length) return;

  var matched = false; 

  $visibleSlides.each(function () {

    if (matched) return false; 

    var position = $(this).data('media-position');

    var $label = $('.jsc-image-label-container[data-media-position="' + position + '"]');

    if ($label.length) {
      $label.removeClass('d-none');
      matched = true; 
    }

  });
}
function showBadgeForSelectedVariant(variantId) {
  // Hide all badges
  $('.variant-badge').addClass('d-none');

  // Show only selected variant badge
  $('.variant-badge[data-variant-id="' + variantId + '"]').removeClass('d-none');
}

// Default badge on page load
$(window).on('load', function () {
  var defaultVariantId = $('.variant-badge').first().data('default-id');
  if (defaultVariantId) {
    showBadgeForSelectedVariant(defaultVariantId);
  }
});
function updateDropdownSoldOut() {
  const productEl = document.querySelector('[data-product-json-custom]');
  if (!productEl) return;

  let productData = JSON.parse(productEl.textContent);
  let variants = productData.product.variants;

  // selected color
  let selectedColor = document.querySelector('.ColorSwatchList .limited-edition .jsc-col-current')?.innerText.trim();


    // document.querySelector('.ColorSwatch__Radio:checked')?.value ||
    // document.querySelector('.jsc-col-current')?.innerText?.trim();

if(selectedColor){
    $('.CustomDropdown__Item').each(function () {
    let size = $(this).data('value');

    let isAvailable = variants.some(v => {
      return v.available && v.option1 === size && v.option2 === selectedColor;
    });

    // reset
    $(this).removeClass('is-soldout');
    $(this).find('.sold-out-label').remove();

    if (!isAvailable) {
      $(this).addClass('is-soldout'); 
      $(this).append('<span class="sold-out-label">Sold Out Online</span>');
    }
  });
}else{
   $('.CustomDropdown__Item').each(function () {
    let size = $(this).data('value');

    let isAvailable = variants.some(v => {
      return v.available && v.option1 === size;
    });

    // reset
    $(this).removeClass('is-soldout');
    $(this).find('.sold-out-label').remove();

    if (!isAvailable) {
      $(this).addClass('is-soldout'); 
      $(this).append('<span class="sold-out-label">Sold Out Online</span>');
    }
  });
}

}
onclickVarColor = (e, col) => {
  var wrapper = $(e).closest('.ColorSwatchList');
  if(!wrapper.length) return;

  wrapper.find('.jsc-col-current').html(col);
  var selectedVariantId = e.getAttribute('data-variant-id');

  var product_gallery = $('.jsc-product-gallery-new-layout').find('.Product__SlideItem');
  var prodTitle = $('#jsc-title').val();
  var matched = false;

  product_gallery.each(function(){
    var $this_alt = $(this).attr('data-alt');
    $(this).addClass('d-none');
    if ($this_alt === col || prodTitle === $this_alt) {
      $(this).removeClass('d-none');
      matched = true;
    }
  });

  // Fallback: if no match, show all images
  if (!matched) {
    product_gallery.removeClass('d-none');
  }

  if ($(window).width() < 1009 ) {
    onloadimgswap(); // reuse mobile swap logic
  } else {
    destroyProductSlider();
  }

  setTimeout(function(){
    var $default_atc_btn = $('.jsc-qty-atc-wrap .jsc-main-atc');
    var varAvailable = $default_atc_btn.attr('disabled') ? 'false' : 'true';
    updateStickyATCsection(varAvailable);
  },100);

  setTimeout(updateDropdownSoldOut,100);
  showBadgeForSelectedVariant(selectedVariantId);
  setTimeout(showImageLabel,100);
}


// On page load, show badge for initially selected variant
// $(document).ready(function() {
//   var initialVariantId = $('#ProductSelect-product-template').val(); // or wherever your selected variant ID is
//   if (initialVariantId) {
//     showBadgeForSelectedVariant(initialVariantId);
//   }
// });
$(document).ready(function () {
  updateDropdownSoldOut();
});

swapcolbundle = (e) => {
  var img = $(e).attr('data-img');
  $(e).parents('.jsc-bundle-item').find('.size-disable').removeClass('size-disable');
  $(e).parents('.jsc-bundle-item').find('.jsc-bundle-item-img img').attr( 'src' , img );
  $(e).parents('.jsc-bundle-item').find('.active-col').removeClass('active-col');
  $(e).addClass('active-col');
  $(e).parents('.jsc-bundle-item').find('.jsc-size-variants .ColorSwatch').each(function(){
    var addonvarTitle = $(this).attr('data-tooltip') + ' / ' + $(e).attr('data-tooltip');
    var addonvarTitlerevert = $(e).attr('data-tooltip') + ' / ' + $(this).attr('data-tooltip');
    var thissize = $(this);
    $(e).parents('.jsc-bundle-item').find('.jsc-product__addon-varlist input').each(function(){
        if ($(this).attr('data-var-title') == addonvarTitle || $(this).attr('data-var-title') == addonvarTitlerevert) {
            if ($(this).attr('data-available') == 'false') {
              thissize.addClass('size-disable');
            }
        }
    });
  });

  $(e).parents('.jsc-bundle-item').find('.size-disable').removeClass('active-size');
}
swapsizebundle = (e) => {
  var addonvarTitle = $(e).attr('data-tooltip') + ' / ' + $(e).parents('.jsc-bundle-item').find('.active-col').attr('data-tooltip');
  var addonvarTitlerevert = $(e).parents('.jsc-bundle-item').find('.active-col').attr('data-tooltip') + ' / ' + $(e).attr('data-tooltip');
  var disabled = false;
  $(e).parents('.jsc-bundle-item').find('.jsc-product__addon-varlist input').each(function(){
      if ($(this).attr('data-var-title') == addonvarTitle || $(this).attr('data-var-title') == addonvarTitlerevert) {
          if ($(this).attr('data-available') == 'false') {
            disabled = true;
          }
      }
  });
  if (disabled) {
    $(e).removeClass('active-size');
  }else{
    $(e).parents('.jsc-bundle-item').find('.active-size').removeClass('active-size');
    $(e).addClass('active-size');
  }
}
atcbundle = (e) => {
  if ($('.jsc-bundle-item').length == $('.active-col').length && $('.jsc-bundle-item').length == $('.active-size').length) {
    console.log("klk");
    var mainID = $('.ProductForm__Option').find(':selected').val();
    var seconds = Math.trunc( new Date().getTime() / 1000);
    var bundleID = mainID + '-' + seconds;
    $('.jsc-bundle-item').each(function(){
      var addonvarTitle = $(this).find('.active-size').attr('data-tooltip') + ' / ' + $(this).find('.active-col').attr('data-tooltip');
      var addonvarTitlerevert = $(this).find('.active-col').attr('data-tooltip') + ' / ' + $(this).find('.active-size').attr('data-tooltip');
      var addoID = '';

      $(this).find('.jsc-product__addon-varlist input').each(function(){
          if ($(this).attr('data-var-title') == addonvarTitle || $(this).attr('data-var-title') == addonvarTitlerevert) {
              addoID = $(this).val();
          }
      });
      var $prop = {};
      $prop['_BundleId'] = bundleID;

      cartJSAddQuery(addoID,1,$prop,true);

    });
    var $prop = {};
    $prop['_MainBundle'] = 'Yes';
    $prop['_BundleId'] = bundleID;
    cartJSAddQuery(mainID,1,$prop,true);
  }else{
    $('.jsc-bundle-error').show();
    setTimeout(function(){
      $('.jsc-bundle-error').hide();
    },1500);
  }
}
removeAlladdon = (keylist) =>{
  var keysplit = keylist.split(",");
  var jsonObj = {};
  for (i=0;i<keysplit.length;i++){
      jsonObj[keysplit[i]] = 0;
      console.log(keysplit[i]);
  }
  CartJS.updateItemQuantitiesById(jsonObj);
}

removeMainnotfull = () =>{
  if ($('.removeBundle').length > 0) {
    $('.removeBundle').each(function(){
      var keysplit = $(this).val().split(",");
      var jsonObj = {};
      for (i=0;i<keysplit.length;i++){
          jsonObj[keysplit[i]] = 0;
          console.log(keysplit[i]);
      }
      CartJS.updateItemQuantitiesById(jsonObj);
    });
  }
}

jscGridColor = (e,varUrl,varImgUrl) => {
  var sizes = '200,400,600,700,800,900,1000,1200';
  var widthArray = sizes.split(',');
  var replacedValues = [];

  widthArray.forEach(function(width) {
    var replacedString = varImgUrl.replace('{width}', width);
    var img_url_and_width = replacedString + ' ' + width + 'w'
    // console.log(img_url_and_width );
    replacedValues.push(img_url_and_width);
  });
  // console.log(replacedValues);

  $(e).parents('.ProductItem__Wrapper').find('.ProductItem__ImageWrapper').attr('href',varUrl);
  $(e).parents('.ProductItem__Wrapper').find('.ProductItem__Image').attr('data-srcset',replacedValues);
  $(e).parents('.ProductItem__Wrapper').find('.ProductItem__Image').attr('srcset',replacedValues);
  // console.log(img_content);

}

swapTabsection = (evt) => {
  $('.jsc-active-tab').removeClass('jsc-active-tab');
  $(evt).addClass('jsc-active-tab');
  $('.jsc-content-tab').each(function() {
    if ($(evt).attr('data-tab') == $(this).attr('data-tab')) {
      $(this).addClass('jsc-active-tab');
    }
  });
}

jscStopVideo = (e) => {
  var $shopify_video = $('.jsc-shopify-video');
  
  $shopify_video.each(function(){
    $(this).attr('src','');
  });
}
jscPlayVideo = (e) => {
  var $desktop_vid = $('.jsc-desktop-featured-video');
  var $mobile_vid = $('.jsc-mobile-featured-video');
  
  if ($(window).width() > 481) {
    var $this_src = $desktop_vid.attr('data-reload');
    $desktop_vid.attr('src',$this_src);
  } else {
    var $this_src = $mobile_vid.attr('data-reload');
    $mobile_vid.attr('src',$this_src);
  }
}

//start: gwp tier
tierGwp = () =>{
  var $addEle = $('.jsc-add-tierGwp');
  var $removeEle = $('.jsc-remove-tierGwp')
  
  $addEle.each(function() {
    var $gwpcart_product = {};
    var $vid = parseInt($(this).attr('data-vid'));
    var $tierNo = $(this).attr('data-tier');
    $gwpcart_product['_GWP Tier '+$tierNo] = true;
    $gwpcart_product['_GWP'] = true;
    if ($(this).length > 0) {
      cartJSAddQuery($vid, 1, $gwpcart_product, true);
    }
  });

  $removeEle.each(function() {
    var $key = $(this).attr('data-key');
    if ($(this).length > 0) {
      cartJSUpdateQuery($key, 0);
    }
  });
}
//end: gwp tier

//start:pdp image slider
initflickityImageSlider = () => {
  //setTimeout( function() {
    if ($('.jsc-image-slider-section .jsc-is-content').length > 0) {
      console.log('flick image slider');
      $('.jsc-image-slider-section .jsc-is-content').flickity({
        // options
        prevNextButtons : true,
        pageDots : false,
        wrapAround : true,
        contain: true,
        cellAlign: 'left',
        draggable: false,
        imagesLoaded : true,
        on: {
          ready: function() {
            $(this.element).addClass('jsc-flickity-initiated');
          }
        }
      });
    }
  //},3500);

}
//end:pdp image slider

//start: pdp label - Final Sale
pdpLabel = (e) => {
  var $getVarData = $('.jsc-metafield-final-sale').find('.jsc-each-var-data');

  setTimeout(function(){
    var $pageUrl = window.location.href;

    $getVarData.each(function(){
      var $thisId = $(this).attr('data-var-id');
      
      if ($pageUrl.includes($thisId)) {
        var $thisShowLabel = $(this).attr('data-show-label');
        // console.log('data-show-label',$thisId,$thisShowLabel);
        if ($thisShowLabel == 'true') {
          $('.jsc-final-sale-label').removeClass('hide-label');
        } else {
          $('.jsc-final-sale-label').addClass('hide-label');
        }
      }
    });
    
  },200);
  
}
//start: pdp label - Final Sale

//start: collection > bottom description read more
onloadCollectionReadMore = () => {
  var $readMoreSection = $('.jsc-bottom-coll-readmore');

  if ($readMoreSection.length > 0) {
    var $getWholeContent = $('.jsc-store-bottom-desc');
    var $readMoreID = $getWholeContent.find('.jsc-coll-readmore-span'); 

    if ($readMoreID.length > 0) { // only runs when read more span is present
      $readMoreSection.find('.moreless-button').removeClass('d-none');
      $('.moreless-button').click(function() {
        $('.jsc-bottom-coll-readmore-inner .moretext').slideToggle();
        if ($('.moreless-button').text() == "READ MORE") {
          $(this).text("READ LESS");
        } else {
          $(this).text("READ MORE");
        }
      });
    }
    
  }
}
//end: collection > bottom description read more

//start: pdp sticky add to cart
onloadStickyATC = () => {
  var section1 = $('.Product__Info form.ProductForm');
  var section2 = $('.jsc-sticky-atc-section');

  if (section2.length > 0) {
    console.log("hello ");
    section2.hide();
    $(window).on('scroll', function() {
        var scrollPosition = $(this).scrollTop();
        var section1Bottom = section1.offset().top + section1.outerHeight();

        if (scrollPosition >= section1Bottom) {
            section2.show();
        } else {
            section2.hide();
        }
    });
  }
}
onclickScrollToSection = (e,section) => {
  if (section == 'top') {
    var scroll_to = $('.PageContainer');
  }
  else if (section == 'jsc-product-tabs') {
    var scroll_to = $('.jsc-product-tabs');
  }
  else if (section == 'reviews') {
    var scroll_to = $('#stamped-main-widget');
  }
  else if (section == 'atc-button') {
    var scroll_to = $('form.ProductForm');
  }

  if (scroll_to.length) {
      var targetOffset = scroll_to.offset().top - 100; // Add 10 pixels for spacing
      $('html, body').animate({
          scrollTop: targetOffset
      }, 1000);
  }
}
updateStickyATCsection = (varAvailable) => {
  //var $default_atc_btn = $('.jsc-qty-atc-wrap .jsc-main-atc');
  var $sticky_section = $('.jsc-sticky-atc-section');
  var $sticky_atc_btn = $('.jsc-sticky-atc-button');
  var $sticky_atc_btn_text = $sticky_atc_btn.find('.jsc-sticky-btn-text');
  var $variant_info = $('.jsc-product-variants-info').children();
  var $page_url = window.location.href;
  var $var_url = $page_url.split("variant=")[1];

  if ($sticky_section.length > 0) {
    $('.jsc-store-currency').removeClass('d-none');
    if (varAvailable == 'false') {
      $('.jsc-sticky-atc-button-default').addClass('d-none');
      //$sticky_atc_btn_text.text('Sold Out');
      $('.jsc-sticky-atc-button.klaviyo-bis-trigger').removeClass('d-none');
      $('.jsc-sticky-atc-button.klaviyo-bis-trigger').css('display','flex');
      //$sticky_atc_btn.addClass('jsc-soldout');
      //console.log('var oos');
      
    } else {
      $('.jsc-sticky-atc-button-default').removeClass('d-none');
      //$sticky_atc_btn_text.text('Add To Cart');
      $('.jsc-sticky-atc-button.klaviyo-bis-trigger').addClass('d-none');
      //console.log('var instock');
      // $sticky_atc_btn.removeClass('jsc-soldout');
    }

    $variant_info.each(function(){
      var $this_id = $(this).attr('data-id');

      if ($this_id == $var_url) {
        var currency_symbol = $('#jsc-cart-currency-symbol').val();

        var $this_title = $(this).attr('data-title');
        var $this_price = $(this).attr('data-price');
        var $this_price_formatted = Shopify.formatMoney($this_price).split("undefined")[1].split(".00")[0];
        var $this_price_compare = $(this).attr('data-c-price');
        var $this_price_c_formatted = Shopify.formatMoney($this_price_compare).split("undefined")[1].split(".00")[0];
        
        $('.jsc-sticky-var-title').text($this_title);
        $('.jsc-sticky-btn-price-selected').text($this_price_formatted);
        $('.jsc-pdp-price').text(`${currency_symbol}${$this_price_formatted}`);
        if ($this_price_compare != '') {
          $('.jsc-sticky-btn-price-compare-selected').text($this_price_c_formatted).parent().show();
          $('.jsc-pdp-compare-price').text(`${currency_symbol}${$this_price_c_formatted}`).show();
        } else {
          $('.jsc-sticky-btn-price-compare-selected').parent().hide();
          $('.jsc-pdp-compare-price').hide();
        }

        if ($(window).width() < 480) {
          var $colour = $this_title.split(" / ")[1];
          var $size = $this_title.split(" / ")[0];
          $('.jsc-sticky-var-colour-title').text($colour);
          $('.jsc-sticky-var-size-title').text($size);
        }
        //console.log($this_id,$this_title,$this_price_formatted);
      }
      
    });
  }
}
onclickStickyATC = () => {
  $('.jsc-main-atc').click();
}
//end: pdp sticky add to cart

//start: pdp size guide popup
jscDisablePageScroll = (e,check) => {

  if (check == 'true') {
    $(e).parents('html').addClass('modal-open');
  } else {
    $(e).parents('html').removeClass('modal-open');
  }
  
}
//end: pdp size guide popup


// start: new mega menu for Shop
jscMegaMenuTab = (e) => {
  var tab_siblings = $(e).siblings('.jsc-sidebar-open-2nd-nav');
  tab_siblings.find('.is-active').removeClass('is-active'); //close other accordion
  tab_siblings.find('.accordion__header .arrow').removeClass('up-arrow');
  tab_siblings.find('.accordion__header .arrow').addClass('down-arrow');

  var currentIsActive = $(e).find('.accordion__header').hasClass('is-active');
  $(e).find('> *').removeClass('is-active');
  $(e).find('.accordion__header .arrow').removeClass('up-arrow');
  $(e).find('.accordion__header .arrow').addClass('down-arrow');

  if(currentIsActive != true) {
    $(e).find('.accordion__header').addClass('is-active');
    $(e).find('.accordion__header .arrow').addClass('up-arrow');
    $(e).find('.accordion__header .arrow').removeClass('down-arrow');
    $(e).find('.accordion__body').addClass('is-active');
  }
}
// end: new mega menu for Shop

// function showDefaultVariantBadgeOnLoad() {
//   // Hide all badges
//   $('.variant-badge').addClass('d-none');

//   // First visible image only
//   var $firstVisibleImage = $('.Product__SlideItem:not(.d-none)').first();
//   if (!$firstVisibleImage.length) return;

//   // Get default selected variant id from badge itself
//   var defaultVariantId = $firstVisibleImage
//     .find('.variant-badge[data-default-id]')
//     .first()
//     .attr('data-default-id');

//   if (!defaultVariantId) return;

//   // Show only matching variant badge
//   $firstVisibleImage
//     .find('.variant-badge[data-variant-id="' + defaultVariantId + '"]')
//     .removeClass('d-none');
// }
function showDefaultVariantBadgeOnLoad() {
  // Hide all badges
  $('.variant-badge').addClass('d-none');

  // Get default variant id
  var defaultVariantId = $('.variant-badge').first().data('default-id');
  if (!defaultVariantId) return;

  // Show matching badge
  $('.variant-badge[data-variant-id="' + defaultVariantId + '"]').removeClass('d-none');
}

$(window).on('load', function () {
  setTimeout(function () {
    showDefaultVariantBadgeOnLoad();
  }, 200);
});

document.addEventListener('click', function (e) {
  var swatch = e.target.closest('.spf-product__swatch');
  if (!swatch) return;

  var variantId = swatch.getAttribute('data-variant-id');
  if (!variantId) return;

  // find parent product card
  var productEl = swatch.closest('.spf-product-card');
  if (!productEl) return;

  // hide all badges for this product
  productEl.querySelectorAll('.jsc-grid-badge-container').forEach(function (badge) {
    badge.classList.add('d-none');
  });

  // show matched badge
  var matchedBadge = productEl.querySelector(
    '.jsc-grid-badge-container[data-variant-id="' + variantId + '"]'
  );

  if (matchedBadge) {
    matchedBadge.classList.remove('d-none');
  }
});

